import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/plantao`

    const headers = { responseType: "arraybuffer" }

    return {
        relatorioPlantao(queryParms) {

            return repository.get(`${baseUrl}/relatorio-plantao?${urlUtil.serialize(queryParms)}`, headers)
        },
    }
}
